// extracted by mini-css-extract-plugin
export default {"info":"info-drai","importantLabel":"importantLabel-o0H6","duplicateLabel":"duplicateLabel-_n7L"};